import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
	VEHICLE_SUBSCRIPTION_CONSULTING_CREATE_PATH,
	VEHICLE_SUBSCRIPTION_CONSULTING_DETAIL_PATH,
} from '../../../../routes/constants/urls';
import Button from '../../../../components/atoms/Button';
import useGridDataWithRTK from '../../../../hooks/useGridData/useGridDataWithRTK';
import userData from './gridData';
import GridContentTemplate from '../../../../components/templates/GridContentTemplate';
import useCheckRole from '../../../../hooks/useCheckRole';
import { useGetSubscriptionVehicleConsultingQuery } from '../../../../store/apis/vehicleSubscriptionConsulting';

const ButtonContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

const VehicleSubscriptionConsulting = () => {
	const { formInitialValues, colsList, forms } = userData();

	const navigate = useNavigate();

	const isCreateVehicleSubscriptionConsulting = useCheckRole({
		roleCategory: '차량구독관리',
		roleName: '신청관리',
		roleType: 'isCreate',
		includeSuper: true,
	});

	const {
		rowData,
		totalCount,
		cols,
		page,
		pageSize,
		setGridApi,
		handlePageChange,
		handlePageSizeChange,
		handleSearchSubmit,
		handleDetailClick,
		isFetching,
	} = useGridDataWithRTK({
		useQuery: useGetSubscriptionVehicleConsultingQuery,
		formInitialValues,
		colsList,
		detailPath: VEHICLE_SUBSCRIPTION_CONSULTING_DETAIL_PATH,
	});

	const handleCreateClick = () => {
		navigate(VEHICLE_SUBSCRIPTION_CONSULTING_CREATE_PATH);
	};

	return (
		<GridContentTemplate
			gridRef={setGridApi}
			mainTitle="차량구독 상담"
			gridTitle="상담 목록"
			totalCount={totalCount}
			currentPage={page}
			currentPageSize={pageSize}
			onPageChange={handlePageChange}
			onPageSizeChange={handlePageSizeChange}
			rowData={rowData}
			cols={cols}
			formInitialValues={formInitialValues}
			forms={forms}
			onSearchSubmit={handleSearchSubmit}
			onRowClicked={handleDetailClick}
			isFetching={isFetching}
			rightAccessory={
				isCreateVehicleSubscriptionConsulting && (
					<ButtonContainer>
						<Button onClick={handleCreateClick} size="small">
							상담등록
						</Button>
					</ButtonContainer>
				)
			}
		/>
	);
};

export default VehicleSubscriptionConsulting;
